/**
 * @internal These tokens should only be used within the design system.
 * Use the typography components or mixins from `@ardoq/typography` instead.
 */
export const fontFamily = {
  regular: `'Inter', -apple-system, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Cantarell', 'Helvetica Neue'`,
};
